"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _BestSelect = _interopRequireDefault(require("./BestSelect"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var YearPickerSelect = function YearPickerSelect(_ref) {
  var value = _ref.value,
    startYear = _ref.startYear,
    endYear = _ref.endYear,
    isDisabled = _ref.isDisabled,
    onChange = _ref.onChange,
    className = _ref.className,
    styles = _ref.styles,
    rest = _objectWithoutProperties(_ref, ["value", "startYear", "endYear", "isDisabled", "onChange", "className", "styles"]);
  var calculateYears = function calculateYears() {
    var years = [];
    for (var i = startYear; i <= endYear; i++) {
      years.push({
        value: i,
        label: i
      });
    }
    return years;
  };
  var findDropdownValue = function findDropdownValue(years, value) {
    return years.find(function (y) {
      return y.value === value;
    });
  };
  var years = calculateYears();
  var dropdownValue = findDropdownValue(years, value);
  return _react["default"].createElement(_BestSelect["default"], _extends({
    name: "year-picker-select",
    value: dropdownValue,
    onChange: onChange,
    options: years,
    disabled: isDisabled,
    className: className,
    clearable: false,
    backspaceRemoves: false,
    deleteRemoves: false,
    styles: styles
  }, rest));
};
YearPickerSelect.propTypes = {
  /** class names to pss to select */
  className: _propTypes["default"].string,
  /** if this is disabled */
  isDisabled: _propTypes["default"].bool,
  /** on change callback */
  onChange: _propTypes["default"].func.isRequired,
  /** value of the component */
  value: _propTypes["default"].number.isRequired,
  /** year to start the select */
  startYear: _propTypes["default"].number,
  /** year to end the select */
  endYear: _propTypes["default"].number,
  /** overrideable styles for the select */
  styles: _propTypes["default"].object
};
YearPickerSelect.defaultProps = {
  className: "",
  startYear: 1900,
  endYear: new Date().getFullYear(),
  isDisabled: false,
  styles: {}
};
var _default = YearPickerSelect;
exports["default"] = _default;